export default "__VITE_ASSET__TbWvZN75__"